import { Dimensions, Platform } from 'react-native';

import { EPGAlignment, EPGConfig } from '../types';

const WINDOW_SIZE = Dimensions.get('window');
const HOUR_WIDTH = (Math.max(WINDOW_SIZE.width, WINDOW_SIZE.height) - 100) / 2;
const TV_HORIZONTAL_SCROLL_AMOUNT = HOUR_WIDTH / 2;

export const DEFAULT_CONFIG: EPGConfig = {
    paddingColor: 'black',
    skeletonCellsColor: 'black',
    padding: 2,
    cellBorderRadius: 4,
    channelWidth: 100,
    timebarHeight: 32,
    rowHeight: 44,
    hoursCount: 24,
    hourWidth: HOUR_WIDTH,
    markerToLineAlignment: EPGAlignment.center,
    stickyMarker: true,
    stickyMarkerPadding: 8,
    stickyPrograms: true,
    stickyProgramTriggerMins: 15,
    stickyProgramReleaseMins: 10,
    tvHorizontalScrollAmount: TV_HORIZONTAL_SCROLL_AMOUNT,
    renderAheadOffsetHorizontal: Platform.isTV
        ? TV_HORIZONTAL_SCROLL_AMOUNT
        : 250,
    renderAheadOffsetVertical: 250,
    needDataDelay: 100,
    preloadEnabled: false,
    idlePeriod: 5000,
    idleRequestCount: 10,
    decelerationRate: Platform.OS === 'ios' ? 0.998 : 0.95,
};
